export default {
    'backgroundPrimary' : '#376888',
    'foregroundPrimary' : '#fcddc9'
};